import styled from 'styled-components';
import { Typography } from '../../../../global/theme';
import { AlignCenter, HideScrollbar, LineClamp } from '../../../../global/commonStyle';

const Div = styled.div`
  height: 100%;
`;
const Container = styled.div`
  background: var(--background-secondary);
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  gap: var(--space-24);
  padding: var(--space-12) var(--space-24);
  border-bottom: 0.5px solid var(--border-primary);
  position: sticky;
  top: 0;
  background: var(--background-secondary);
  z-index: var(--z-index-99);
`;
const LeftHeader = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
  .fillColor {
    cursor: pointer;
    stroke: var(--text-primary);
    &:hover {
      background: var(--neutral-secondary);
      border-radius: var(--border-radius-4);
    }
  }
`;
const Titles = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  h1 {
    ${Typography.body_md_medium}
    color: var(--text-primary);
    margin: var(--space-0);
    ${LineClamp(1)}
    word-break: break-all;
  }
  p {
    ${Typography.body_xs}
    color: var(--text-secondary);
    margin: var(--space-0);
  }
`;
const Buttons = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  ${HideScrollbar}
  .pg-viewer-wrapper {
    height: 100%;
    background: var(--background-secondary);
    ${HideScrollbar}
    .unsupported-message {
      background: var(--background-primary);
      color: var(--text-primary);
    }
  }
  .pg-viewer-wrapper img {
    border-radius: var(--border-radius-8);
  }
  .pdf-viewer {
    margin: var(--space-24) auto;
  }
  .pdf-viewer-container {
    overflow-y: scroll;
    height: calc(100dvh - 60px);
  }
  .pdf-canvas {
    box-shadow: var(--shadow-card);
    border: 0.5px solid var(--border-primary);
    margin: var(--space-0) auto;
    width: max-content;
    display: flex;
  }
  video {
    max-width: 980px;
    width: 100%;
    max-height: 571px;
    height: 100%;
  }
`;

export { Container, Header, LeftHeader, Titles, Buttons, Content, Div };
